import { render, staticRenderFns } from "./COption.vue?vue&type=template&id=723cba88&scoped=true&"
import script from "./COption.vue?vue&type=script&lang=js&"
export * from "./COption.vue?vue&type=script&lang=js&"
import style0 from "./COption.vue?vue&type=style&index=0&id=723cba88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723cba88",
  null
  
)

export default component.exports